import React from 'react';
import { twMerge } from 'tailwind-merge';

type CounterProps = React.HTMLAttributes<HTMLSpanElement> & {
  count: number;
};

export const Counter: React.FC<CounterProps> = ({ count, className, ...props }) => {
  return (
    <span
      className={twMerge('flex min-w-[24px] items-center justify-center rounded-full bg-[#EAEFF0] px-2 py-1 text-xs text-[#576063]', className)}
      {...props}
    >
      {count}
    </span>
  );
};